import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsys.fund.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsys-fund-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsys.fund.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysFundItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() status: any;
    @Input() fund_id: any;
    @Input() menu: any;

    public fund: any = null;
    public role: any;
    public fund_status: any;
    public investments: any = [];
    public isUserStatus: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public isLoading: boolean = false;

    public async load() {
        if (this.isLoading) return;
        this.isLoading = true;
        const { data } = await wiz.call("info", { id: this.fund_id });
        this.fund = data.info;
        this.role = data.role;
        this.fund_status = data.status;
        this.investment = data.investment;

        this.isUserStatus = false;
        try {
            this.isUserStatus = ['참여', '대기', '신청', '해산'].includes(this.fund_status.status);
        } catch (e) {
        }

        this.isLoading = false;
        await this.service.render();
    }

    public linkFundMenu(menu: string) {
        return `/fund/${this.status}/${this.fund_id}/${menu}`;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }

    public toNumber(value) {
        if (value === null || value === undefined || value === '') return 0;
        return Number(String(value).replace(/,/g, '')) || 0;
    }

    public contributionAmount() {
        return this.toNumber(this.fund_status?.applied_amount) * this.toNumber(this.fund?.amount_per_share);
    }

    public paidAmount() {
        const saved = this.toNumber(this.fund_status?.joined_budget || this.fund_status?.extra?.contribution_paid || this.fund_status?.extra?.paid_amount);
        if (saved > 0) return saved;
        return Math.floor(this.contributionAmount() * this.toNumber(this.fund?.extra?.finished_amount_rate) / 100);
    }

    public isDelegatedReadonly() {
        return !!this.fund_status?._delegated_readonly;
    }

    public recoveredAmount() {
        const sell = this.fund_status?.extra?.sell || {};
        let total = 0;
        for (let investmentId in sell) {
            const rows = Array.isArray(sell[investmentId]) ? sell[investmentId] : [];
            for (let row of rows) total += this.toNumber(row?.amount);
        }
        return total;
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }
}

export default PortalLpsysFundItemComponent;